import React, { useEffect, useState } from "react";
import { companyService } from "services";
import { TbInfoCircle } from "react-icons/tb";
import { useTranslation } from "react-i18next";

const DocumentsSignaturesBanner = () => {
    const { t } = useTranslation();
    const [allowance, setAllowance] = useState(null);
    const [used, setUsed] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;
        companyService
            .getAccountsProductUsage()
            .then((res) => {
                if (!isMounted) return;
                const data = res?.data || res; // handleResponse in servicios suele envolver en { data }
                setAllowance(data?.signatures_allowance ?? null);
                setUsed(data?.signatures_used ?? null);
                setLoading(false);
            })
            .catch((e) => {
                if (!isMounted) return;
                setError(e);
                setLoading(false);
            });
        return () => {
            isMounted = false;
        };
    }, []);

    if (loading) return null;

    // Sin contrato o sin allowance
    if (error || allowance === null || allowance === 0) {
        return (
            <div className="documents-info-banner visible">
                <span className="icon"><TbInfoCircle size={22} /></span>
                <span className="text">{t("documents.noSignaturesAvailable")}</span>
            </div>
        );
    }

    const remaining = Math.max(allowance - (used || 0), 0);

    return (
        <div className="documents-info-banner visible">
            <span className="icon"><TbInfoCircle size={22} /></span>
            <span className="text">{t("documents.signaturesRemaining", { remaining, allowance })}</span>
        </div>
    );
};

export default DocumentsSignaturesBanner;


